import { useState } from "react";
import { createContext } from "react";

export const SelectorContext = createContext({
    isSelectorOpen: false,
    setSelectorState: () => null,
}
);

export const SelectorProvider = ({children}) => {
    const [isSelectorOpen, setSelectorState] = useState(null);
    const value = {isSelectorOpen, setSelectorState};
    return <SelectorContext.Provider value={value}>{children}</SelectorContext.Provider>
};